import React, { useState, useEffect, useContext } from "react";
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { createPackage, getPackage, getTaxGroupList } from "../../Services/Packages.service";
import { formatDateTime, getCarTypes, getCorporateClientsBySeviceCityIdWithoutPagination, getUserDetails, showAlert } from "../../Services/Shared.service";
import { ArrowDown, ArrowUp } from "react-feather";
import { CommonModal } from "../../AbstractElements";
import { addMonths, addSeconds } from "date-fns";
import { createRate, getRate, updateRate } from "../../Services/Rates.service";
import moment from "moment";
import { useRateConstraints, validatePerKmCharge } from "../../hooks/useRateConstraints";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { Box, Drawer, Typography } from "@mui/material";
import closeIcon from "../../assets/images/tarrifManagement/closeIcon.svg";
import SharedDataContext from "../../_helper/SharedData";

const RateInput = ({
  //   cityData,
  //   airportData,
  //   editId,
  //   setIsOpen,
    fetchTableData,
  //   isOpen,
  //   setEditId,
  editId,
  open,
  setIsOpen,
}) => {
      const {
          register,
          control,
          handleSubmit,
          formState: { errors },
          setValue,
          getValues,
          reset,watch
        } = useForm({
        defaultValues: {
            timeFrom: "",
            timeTo: "",
            isActive: true,
            initialDist: "",
            initialDistCharge: "",
            perKmCharge: "",
            waitingChargePerMin: "",
            waitingChargeAfterTimeInMin: "",
            tripTimeChargePerMin: "",
            waitingCalcThresholdSpeed: "",
            serviceCity: {},
            baseFareTax: {},
            serviceTax: {},
            corporateClient: {},
            carTypeDropdown: {},
            discountLocationId: "",
            isNightfareTimeSlot: false,
            applicableFromDate: new Date(),
            applicableToDate: addMonths(new Date(), 1),
            airportDropdown: {},
            bookingSource: "",
            rideType: "",
            isPriority: false
        },
      });
      const { overallTax } = watch();
  const { cityData, globalCityField, setShowApiLoader, airportData } =
    useContext(SharedDataContext);
  const values = getValues();
  const [taxData, setTaxData] = useState([]);
  const [corporateClientData, setCorporateClientData] = useState([]);
  const [carTypeData, setCarTypeData] = useState([]);
  const [airportCityData, setAirportCityData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rateObj, setRateObj] = useState({});
  const [isAdvanced, setIsAdvanced] = useState(false);
  const { mix_background_layout } = useContext(CustomizerContext);
  const [combinedTax, setCombinedTax] = useState([]);
  const [selectedTax, setSelectedTax] = useState({});
  const [isEditRate, setIsEditRate] = useState({
    DrawerState: "false",
    selectedRateId: "",
  });
  const rewardConstraints = useRateConstraints(open);

  // useEffect(()=>{
  //     console.log("applicableToDate",applicableToDate)
  // },[applicableToDate])


  useEffect(() => {
    getTaxGroupList().then((result) => {
      if (result.status == 200) {
        // const data = result.data.map((element) => {
        //     return {
        //         value: element,
        //         label: element.name,
        //     };
        // });
        setTaxData(result.data);
        setCombinedTax(generateTaxCombinationsForSelectBox(result.data));
      }
    });
  }, []);

  function generateTaxCombinationsForSelectBox(taxData) {
    // const combinations = [];

    // taxData.forEach(baseTax => {
    //     taxData.forEach(serviceTax => {
    //         const label = `Base ${baseTax.value.taxPercentage=== "5%" ?"2.5%":"0%"} Service ${serviceTax.value.taxPercentage=== "5%" ?"2.5%":"0%"}`;
    //         const value = {
    //             baseTax: baseTax.value,
    //             serviceTax: serviceTax.value
    //         };
    //         combinations.push({ label, value });
    //     });
    // // } );
    // const base5 = taxData.find((t) => t.value.taxPercentage === "5%");
    // const base0 = taxData.find((t) => t.value.taxPercentage === "0%");
    // const service18 = taxData.find((t) => t.value.taxPercentage === "18%");
    // const service0 = taxData.find((t) => t.value.taxPercentage === "0%");
    // combinations.push({
    //   label: `Base 5% Service 18%`,
    //   value: { baseTax: base5.value, serviceTax: service18.value },
    // });
    // combinations.push({
    //   label: `Base 0% Service 0%`,
    //   value: { baseTax: base0.value, serviceTax: service0.value },
    // });

    // return combinations;
    let basezero = taxData.filter((t) => t.taxRate === 0);
    let basenonzero = taxData.filter((t) => t.taxRate !== 0);
    console.log("Base Zero :", basezero);
    basezero.sort((a, b) => a.taxCategory.localeCompare(b.taxCategory));
    basenonzero.sort((a, b) => a.taxCategory.localeCompare(b.taxCategory));
    let combinations = [];
    combinations.push({
      label: `Base ${basenonzero[0].taxRate}% Service ${basenonzero[1].taxRate}%`,
      value: { baseTax: basenonzero[0], serviceTax: basenonzero[1] },
    });
    combinations.push({
      label: `Base ${basezero[0].taxRate}% Service ${basezero[1].taxRate}%`,
      value: { baseTax: basezero[0], serviceTax: basezero[1] },
    });
    return combinations;
  }

  const bookingSourceData = [
    { value: "Partner", label: "Partner" },
    { value: "Customer", label: "Customer" },
    { value: "Kiosk", label: "Kiosk" },
    { value: "Website", label: "Website" },
    { value: "TMS", label: "TMS" },
    { value: "ThirdParty", label: "ThirdParty" },
    { value: "ALL", label: "ALL" },
  ];

  const rideTypeData = [
    { value: "RideLater", label: "C2A" },
    { value: "KurbPickup", label: "KurbPickup" },
    { value: "AirportPickup", label: "A2C" },
    { value: "ALL", label: "ALL" },
  ];

  const isActiveField = useController({
    name: "isActive",
    control,
  }).field;

  const isPriorityField = useController({
    name: "isPriority",
    control,
  }).field;

  const isNightfareTimeSlotField = useController({
    name: "isNightfareTimeSlot",
    control,
  }).field;

  const serviceCityField = useController({
    name: "serviceCity",
    control,
    rules: {
      required: {
        value: true,
        message: "Service City is Required",
      },
      validate: (value) => {
        if (!value || !value.id) {
          return "Service City is Required";
        }
        return true;
      },
    },
  }).field;

  const handleServiceCitySelectChange = (data) => {
    serviceCityField.onChange(data.value);
  };

  const baseFareTaxField = useController({
    name: "baseFareTax",
    control,
    rules: {
      // required: {
      //   value: true,
      //   message: "Tax is Required",
      // },
    },
  }).field;

  const handleBaseFareTax = (data) => {
    baseFareTaxField.onChange(data.value);
  };

  const serviceTaxField = useController({
    name: "serviceTax",
    control,
    rules: {
      required: {
        value: true,
        message: "Tax is Required",
      },
      validate: (value) => {
        if (!value || !value.taxGroupId) {
          return "Tax is Required";
        }
        return true;
      },
    },
  }).field;

  const handleServiceFareTax = (data) => {
    serviceTaxField.onChange(data.value);
  };

  const corporateClientField = useController({
    name: "corporateClient",
    control,
    rules: {
      // required: {
      //     value: true,
      //     message: "Corporate Client is Required",
      // },
    },
  }).field;

  const handleCorporateClientSelectChange = (data) => {
    corporateClientField.onChange(data.value);
  };

  const applicableToDateField = useController({
    name: "applicableToDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable To Date is Required",
      },
      validate: (value) => {
        const from = applicableFromDateField.value; // THE FROM DATE
        if (from && value && value < from) {
          return "Available To Date cannot be earlier than Available From Date";
        }
        return true;
      },
    },
  }).field;

  const handleApplicableToDate = (data) => {
    applicableToDateField.onChange(data);
  };

  const applicableFromDateField = useController({
    name: "applicableFromDate",
    control,
    rules: {
      required: {
        value: true,
        message: "Applicable From Date is Required",
      },
    },
  }).field;

  const handleApplicableFromDate = (data) => {
    applicableFromDateField.onChange(data);
  };

  const carTypeField = useController({
    name: "carTypeDropdown",
    control,
    rules: {
      required: {
        value: true,
        message: "Car type is Required",
      },
      validate: (value) => {
        if (!value || !value.id) {
          return "Car type is Required";
        }
        return true;
      },
    },
  }).field;

  const handleCarTypeSelectChange = (data) => {
    carTypeField.onChange(data.value);
  };

  const bookingSourceField = useController({
    name: "bookingSource",
    control,
    rules: {
      required: {
        value: true,
        message: "Booking Source is Required",
      },
    },
  }).field;

  const handleBookingSourceSelectChange = (data) => {
    bookingSourceField.onChange(data.value);
  };

  const rideTypeField = useController({
    name: "rideType",
    control,
    rules: {
      required: {
        value: true,
        message: "Ride Type is Required",
      },
    },
  }).field;

  const handleRideTypeSelectChange = (data) => {
    rideTypeField.onChange(data.value);
  };

  const timeFromField = useController({
    name: "timeFrom",
    control,
    rules: {
      required: {
        value: true,
        message: "Time From is Required",
      },
    },
  }).field;

  const handleTimeFrom = (data) => {
    timeFromField.onChange(data);
  };

  const timeToField = useController({
    name: "timeTo",
    control,
    rules: {
      required: {
        value: true,
        message: "Time To is Required",
      },
      validate: (value) => {
        if (!value || !timeFromField.value) return true; // skip if no data yet

        const from = new Date(timeFromField.value).getHours();
        const to = new Date(value).getHours();

        // Allow ONLY 12 AM → 12 AM
        if (from === 0 && to === 0) return true;

        // Reject same time (except 12→12)
        if (from === to) return "Start time and end time cannot be the same";

        // Reject lesser time
        if (to != 0 && to < from)
          return "Time To should be greater than Time From";

        return true;
      },
    },
  }).field;

  const handleTimeTo = (data) => {
    timeToField.onChange(data);
  };

  const airportField = useController({
    name: "airportDropdown",
    control,
    rules: {
      required: {
        value: true,
        message: "Airport is Required",
      },
      validate: (value) => {
        if (!value || !value.id) {
          return "Airport is Required";
        }
        return true;
      },
    },
  }).field;

  const handleAirportSelectChange = (option) => {
    if (!option) {
      return airportField.onChange(null);
    }
    airportField.onChange({
      id: option.value.id,
      name: option.value.name,
      terminal: option.value.shortName,
    });
  };

  useEffect(() => {
    const serviceCityId = serviceCityField.value?.id;
    if (!serviceCityId) {
      setCarTypeData([]);
      return;
    }
    let array = [];
    airportData.forEach((element) => {
      if (element.serviceCityId == serviceCityId) {
        array.push({
          value: element,
          label: element.name,
        });
      }
    });
    setAirportCityData(array);
    let obj = {
      serviceCityId,
      // travelType: rideTypeField.value == "AirportPickup" ? "A2C" : "C2A",
      // travelType: "A2C",
    };
    getCarTypes(obj)
      .then((result) => {
        const data = result.data.map((element) => {
          return {
            label: element.name,
            value: element,
          };
        });
        setCarTypeData(data);
      })
      .catch((err) => {
        showAlert("error", "Unable to fetch Car details for selected City");
      });

    getCorporateClientsBySeviceCityIdWithoutPagination(obj).then((result) => {
      if (result.status == 200) {
        const data = result.data.list.map((element) => {
          return {
            value: element,
            label: element.companyName,
          };
        });
        setCorporateClientData(data);
      }
    });
  }, [serviceCityField.value]);

  // console.log("values", values)

  useEffect(() => {
    if (editId && open) {
      getRate(editId)
        .then((resp) => {
          let rateObj = resp.data;
          console.log("getRate", resp.data);
          setRateObj(resp.data);
          const serviceCity = cityData.find((element) => {
            return element?.value?.id === rateObj?.serviceCityId;
          });

          setSelectedTax(
            findOption(resp.data.baseFareTax, resp.data.serviceTax)
          );

          reset({
            timeFrom: addSeconds(
              new Date().setHours(0, 0, 0, 0),
              rateObj.timeFrom
            ),
            timeTo: rateObj.timeTo
              ? addSeconds(new Date().setHours(0, 0, 0, 0), rateObj.timeTo)
              : "",
            isActive: rateObj?.isActive ? rateObj?.isActive : false,
            initialDist: rateObj.initialDist ? rateObj.initialDist : "",
            initialDistCharge: rateObj.initialDistCharge
              ? rateObj.initialDistCharge
              : 0,
            perKmCharge: rateObj.perKmCharge ? rateObj.perKmCharge : 0,
            waitingChargePerMin: rateObj.waitingChargePerMin
              ? rateObj.waitingChargePerMin
              : 0,
            waitingChargeAfterTimeInMin: rateObj.waitingChargeAfterTimeInMin
              ? rateObj.waitingChargeAfterTimeInMin
              : 0,
            tripTimeChargePerMin: rateObj.tripTimeChargePerMin
              ? rateObj.tripTimeChargePerMin
              : 0,
            waitingCalcThresholdSpeed: rateObj.waitingCalcThresholdSpeed
              ? rateObj.waitingCalcThresholdSpeed
              : 0,
            serviceCity: rateObj?.serviceCityId
              ? { id: serviceCity.value.id, name: serviceCity.value.name }
              : {},
            baseFareTax: rateObj?.baseFareTaxId
              ? { taxGroupId: rateObj?.baseFareTaxId, name: rateObj?.baseFareTaxName }
              : {},
            serviceTax: rateObj?.serviceTaxId
              ? { taxGroupId: rateObj?.serviceTaxId, name: rateObj?.serviceTaxName }
              : {},
            corporateClient: rateObj?.corporateClientId
              ? {
                  id: rateObj?.corporateClientId,
                  companyName: rateObj?.corporateClientName,
                }
              : {},
            carTypeDropdown: rateObj?.carTypeId
              ? { id: rateObj?.carTypeId, name: rateObj?.carTypeName }
              : {},
            discountLocationId: rateObj.discountLocationId
              ? rateObj.discountLocationId
              : "",
            isNightfareTimeSlot: rateObj?.isActive ? rateObj?.isActive : false,
            applicableFromDate: rateObj?.applicableFromDate
              ? new Date(rateObj?.applicableFromDate)
              : new Date(),
            applicableToDate: rateObj?.applicableToDate
              ? new Date(rateObj?.applicableToDate)
              : addMonths(new Date(), 1),
            airportDropdown: rateObj?.airportId
              ? (() => {
                  const airport = airportData.find(
                    (a) => a.id === rateObj.airportId
                  );
                  return airport
                    ? { id: airport.id, name: airport.name , terminal: airport.shortName }
                    : null;
                })()
              : null,
            bookingSource: rateObj.bookingSource ? rateObj.bookingSource : "",
            rideType: rateObj.rideType ? rateObj.rideType : "",
            isPriority: rateObj?.isPriority ? rateObj?.isPriority : false,
          });
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  }, [editId,open]);

  useEffect(() => {
    if (rateObj && rateObj.baseFareTaxId && rateObj.serviceTaxId) {
      const matchedTax = combinedTax.find(
        (item) =>
          item.value.baseTax.taxGroupId === rateObj.baseFareTaxId &&
          item.value.serviceTax.taxGroupId === rateObj.serviceTaxId
      );
      setValue("overallTax", matchedTax);
      setValue("baseFareTax", matchedTax?.value.baseTax);
      setValue("serviceTax", matchedTax?.value.serviceTax);
    } else {
      // No corporate client → reset to placeholder
      setValue("overallTax", null);
    }
  }, [rateObj, combinedTax, setValue]);

  function findOption(baseTaxId, serviceTaxId) {
    console.log("base and service id ", baseTaxId, serviceTaxId);
    return combinedTax.find((item) => {
      return (
        item.value.baseTax.id === baseTaxId &&
        item.value.serviceTax.id === serviceTaxId
      );
    });
  }
  const handleTime_To = (time, constraint) => {
    let timeto =
      constraint == "S"
        ? Number(moment.duration(moment(time).format("HH:mm:ss")).asSeconds())
        : Number(moment.duration(moment(time).format("HH:mm:ss")).asMinutes());
    if (timeto === 0 && constraint == "S") {
      return 86400;
    } else if (timeto === 0 && constraint == "M") {
      return 1440;
    }
    return timeto;
  };
  const onFormSubmit = (formValues) => {
    setIsSubmitting(true);
    const body = {
      timeFrom: formValues.timeFrom
        ? Number(
            moment
              .duration(moment(formValues.timeFrom).format("HH:mm:ss"))
              .asSeconds()
          )
        : 0,
      timeTo: formValues.timeTo ? handleTime_To(formValues.timeTo, "S") : 0,
      isActive: formValues.isActive ? true : false,
      initialDist: formValues.initialDist ? Number(formValues.initialDist) : 0,
      initialDistCharge: formValues.initialDistCharge
        ? Number(formValues.initialDistCharge)
        : 0,
      perKmCharge: formValues.perKmCharge ? Number(formValues.perKmCharge) : 0,
      waitingChargePerMin: formValues.waitingChargePerMin
        ? Number(formValues.waitingChargePerMin)
        : 0,
      waitingChargeAfterTimeInMin: formValues.waitingChargeAfterTimeInMin
        ? Number(formValues.waitingChargeAfterTimeInMin)
        : 0,
      tripTimeChargePerMin: formValues.tripTimeChargePerMin
        ? Number(formValues.tripTimeChargePerMin)
        : 0,
      waitingCalcThresholdSpeed: formValues.waitingCalcThresholdSpeed
        ? Number(formValues.waitingCalcThresholdSpeed)
        : 0,
      serviceCityId: formValues.serviceCity?.id
        ? formValues.serviceCity.id
        : null,
      serviceCityName: formValues.serviceCity?.name
        ? formValues.serviceCity.name
        : "",
      baseFareTaxId: formValues.baseFareTax?.taxGroupId
        ? formValues.baseFareTax.taxGroupId
        : "",
      baseFareTaxName: formValues.baseFareTax?.name
        ? formValues.baseFareTax.name
        : "",
      corporateClientId: formValues.corporateClient?.id
        ? formValues.corporateClient.id
        : null,
      corporateClientName: formValues.corporateClient?.companyName
        ? formValues.corporateClient.companyName
        : null,
      discountLocationId: formValues.discountLocationId
        ? formValues.discountLocationId
        : null,
      isNightfareTimeSlot: formValues.isNightfareTimeSlot ? true : false,
      serviceTaxName: formValues.serviceTax?.name
        ? formValues.serviceTax.name
        : "",
      carTypeId: formValues.carTypeDropdown?.id
        ? formValues.carTypeDropdown.id
        : 0,
      carTypeName: formValues.carTypeDropdown?.name
        ? formValues.carTypeDropdown.name
        : "Any",
      serviceTaxId: formValues.serviceTax?.taxGroupId
        ? formValues.serviceTax.taxGroupId
        : "",
      applicableFromDate: formValues?.applicableFromDate
        ? new Date(formValues?.applicableFromDate)
        : "",
      applicableToDate: formValues?.applicableToDate
        ? new Date(formValues?.applicableToDate)
        : "",
      airportId: formValues.airportDropdown?.id
        ? formValues.airportDropdown.id
        : "",
      terminal: formValues.airportDropdown?.terminal
        ? formValues.airportDropdown.terminal
        : "",
      airportName: formValues.airportDropdown?.name
        ? formValues.airportDropdown.name
        : "",
      bookingSource: formValues.bookingSource ? formValues.bookingSource : "",
      rideType: formValues.rideType ? formValues.rideType : "",
      isPriority: formValues?.isPriority ? formValues?.isPriority : false,
    };
    if (rateObj?.id) {
      body["id"] = rateObj?.id;
      updateRate(body)
        .then((result) => {
          reset({
            timeFrom: "",
            timeTo: "",
            isActive: true,
            initialDist: "",
            initialDistCharge: "",
            perKmCharge: "",
            waitingChargePerMin: "",
            waitingChargeAfterTimeInMin: "",
            tripTimeChargePerMin: "",
            waitingCalcThresholdSpeed: "",
            serviceCity: {},
            baseFareTax: {},
            serviceTax: {},
            corporateClient: {},
            carTypeDropdown: {},
            discountLocationId: "",
            isNightfareTimeSlot: false,
            applicableFromDate: new Date(),
            applicableToDate: addMonths(new Date(), 1),
            airportDropdown: {},
            bookingSource: "",
            rideType: "",
            isPriority: false,
          });
          showAlert("success", "Rate Updated Successfully");
          fetchTableData();
          setIsSubmitting(false);
          //   setEditId("");
          setRateObj({});
          setIsOpen(false);
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
        setIsSubmitting(false);
    } else {
      createRate(body)
        .then((result) => {
          reset({
            timeFrom: "",
            timeTo: "",
            isActive: true,
            initialDist: "",
            initialDistCharge: "",
            perKmCharge: "",
            waitingChargePerMin: "",
            waitingChargeAfterTimeInMin: "",
            tripTimeChargePerMin: "",
            waitingCalcThresholdSpeed: "",
            serviceCity: {},
            baseFareTax: {},
            serviceTax: {},
            corporateClient: {},
            carTypeDropdown: {},
            discountLocationId: "",
            isNightfareTimeSlot: false,
            applicableFromDate: new Date(),
            applicableToDate: addMonths(new Date(), 1),
            airportDropdown: {},
            bookingSource: "",
            rideType: "",
            isPriority: false,
          });
          showAlert("success", "Rate Created Successfully");
          //   fetchTableData();
          setIsSubmitting(false);
          setIsOpen(false);
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
          setIsSubmitting(false);
        });
    }
  };

  return (
    // <CommonModal
    //     isOpen={isOpen}
    //     title={editId ? "Edit Rate" : "Create Rate"}
    //     toggler={() => {
    //         reset({
    //             timeFrom: "",
    //             timeTo: "",
    //             isActive: true,
    //             initialDist: "",
    //             initialDistCharge: "",
    //             perKmCharge: "",
    //             waitingChargePerMin: "",
    //             waitingChargeAfterTimeInMin: "",
    //             tripTimeChargePerMin: "",
    //             waitingCalcThresholdSpeed: "",
    //             serviceCity: {},
    //             baseFareTax: {},
    //             serviceTax: {},
    //             corporateClient: {},
    //             carTypeDropdown: {},
    //             discountLocationId: "",
    //             isNightfareTimeSlot: false,
    //             applicableFromDate: new Date(),
    //             applicableToDate: addMonths(new Date(), 1),
    //             airportDropdown: {},
    //             bookingSource: "",
    //             rideType: "",
    //             isPriority: false
    //         })
    //         setEditId("")
    //         setRateObj({})
    //         setIsOpen(!isOpen)
    //     }}
    //     size="xl"
    // >
    //     <Form onSubmit={handleSubmit(onFormSubmit)}>
    //         <Row>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Time From (Hours)</Label>
    //                 <Col lg="12">
    //                     <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
    //                         <DatePicker
    //                             className="form-control datetimepicker-input digits"
    //                             selected={timeFromField.value}
    //                             onChange={handleTimeFrom}
    //                             showTimeSelect
    //                             showTimeSelectOnly
    //                             timeIntervals={60}
    //                             timeCaption="Time"
    //                             dateFormat="H:mm"
    //                             timeFormat="H:mm"
    //                             onKeyDown={(e) => {
    //                                 e.preventDefault();
    //                             }}

    //                         />
    //                     </InputGroup>
    //                     <span style={{ color: "red" }}>{errors?.timeFrom?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Time To (Hours)</Label>
    //                 <Col lg="12">
    //                     <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
    //                         <DatePicker
    //                             className="form-control datetimepicker-input digits"
    //                             selected={timeToField.value}
    //                             onChange={handleTimeTo}
    //                             showTimeSelect
    //                             showTimeSelectOnly
    //                             timeIntervals={60}
    //                             timeCaption="Time"
    //                             dateFormat="H:mm"
    //                             timeFormat="H:mm"
    //                             onKeyDown={(e) => {
    //                                 e.preventDefault();
    //                             }}
    //                         />
    //                     </InputGroup>
    //                     <span style={{ color: "red" }}>{errors?.timeTo?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6" style={{ display: "flex", alignItems: "center" }}>
    //                 <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
    //                     <Input id="IsActive" type="checkbox" checked={isActiveField.value}
    //                         onChange={(value) => isActiveField.onChange(value)} />
    //                     <Label className="mb-0" for="IsActive">{"Available {Yes/No}"}</Label>
    //                 </div>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6" style={{ display: "flex", alignItems: "center" }}>
    //                 <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
    //                     <Input id="IsPriority" type="checkbox" checked={isPriorityField.value}
    //                         onChange={(value) => isPriorityField.onChange(value)} />
    //                     <Label className="mb-0" for="IsPriority">{"Is Priority"}</Label>
    //                 </div>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Initial Distance</Label>
    //                 <Col lg="12">
    //                     <input
    //                         className="form-control"
    //                         type="text"
    //                         pattern="[0-9.]+"
    //                         {...register("initialDist", {
    //                             required: {
    //                                 value: true,
    //                                 message: "Initial Distance is required",
    //                             },
    //                             onChange: (e) => {
    //                                 let value = e.target.value.replace(/[^\d.-]/g, '');
    //                                 let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
    //                                 setValue("initialDist", sanitizedValue)
    //                             }
    //                         })}
    //                     />
    //                     <span style={{ color: "red" }}>{errors?.initialDist?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Initial Distance Charge</Label>
    //                 <Col lg="12">
    //                     <input
    //                         className="form-control"
    //                         type="text"
    //                         pattern="[0-9.]+"
    //                         {...register("initialDistCharge", {
    //                             required: {
    //                                 value: true,
    //                                 message: "Initial Distance Charge is required",
    //                             },
    //                             onChange: (e) => {
    //                                 let value = e.target.value.replace(/[^\d.-]/g, '');
    //                                 let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
    //                                 setValue("initialDistCharge", sanitizedValue)
    //                             }
    //                         })}
    //                     />
    //                     <span style={{ color: "red" }}>{errors?.initialDistCharge?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Per Km Charge</Label>
    //                 <Col lg="12">
    //                     <input
    //                         className="form-control"
    //                         type="text"
    //                         pattern="[0-9.]+"
    //                         {...register("perKmCharge", {
    //                             required: {
    //                                 value: true,
    //                                 message: "Per Km Charge is required",
    //                             },
    //                             onChange: (e) => {
    //                                 let value = e.target.value.replace(/[^\d.-]/g, '');
    //                                 let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
    //                                 setValue("perKmCharge", sanitizedValue)
    //                             }
    //                         })}
    //                     />
    //                     <span style={{ color: "red" }}>{errors?.perKmCharge?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Waiting Charge Per Min</Label>
    //                 <Col lg="12">
    //                     <input
    //                         className="form-control"
    //                         type="text"
    //                         pattern="[0-9.]+"
    //                         {...register("waitingChargePerMin", {
    //                             required: {
    //                                 value: true,
    //                                 message: "Waiting Charge Per Min is required",
    //                             },
    //                             onChange: (e) => {
    //                                 let value = e.target.value.replace(/[^\d.-]/g, '');
    //                                 let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
    //                                 setValue("waitingChargePerMin", sanitizedValue)
    //                             }
    //                         })}
    //                     />
    //                     <span style={{ color: "red" }}>{errors?.waitingChargePerMin?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Waiting Charge After Time In Min</Label>
    //                 <Col lg="12">
    //                     <input
    //                         className="form-control"
    //                         type="text"
    //                         pattern="[0-9.]+"
    //                         {...register("waitingChargeAfterTimeInMin", {
    //                             required: {
    //                                 value: true,
    //                                 message: "Waiting Charge After Time In Min is required",
    //                             },
    //                             onChange: (e) => {
    //                                 let value = e.target.value.replace(/[^\d.-]/g, '');
    //                                 let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
    //                                 setValue("waitingChargeAfterTimeInMin", sanitizedValue)
    //                             }
    //                         })}
    //                     />
    //                     <span style={{ color: "red" }}>{errors?.waitingChargeAfterTimeInMin?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Waiting Calculation Threshold Speed</Label>
    //                 <Col lg="12">
    //                     <input
    //                         className="form-control"
    //                         type="text"
    //                         pattern="[0-9.]+"
    //                         {...register("waitingCalcThresholdSpeed", {
    //                             required: {
    //                                 value: true,
    //                                 message: "Waiting Calculation Threshold Speed is required",
    //                             },
    //                             onChange: (e) => {
    //                                 let value = e.target.value.replace(/[^\d.-]/g, '');
    //                                 let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
    //                                 setValue("waitingCalcThresholdSpeed", sanitizedValue)
    //                             }
    //                         })}
    //                     />
    //                     <span style={{ color: "red" }}>{errors?.waitingCalcThresholdSpeed?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Service City</Label>
    //                 <Col lg="12">
    //                     <div className="city-select">
    //                         <CustomSelect
    //                             className="service-select"
    //                             classNamePrefix="select"
    //                             isClearable={false}
    //                             isSearchable={false}
    //                             value={serviceCityField?.value?.id ? cityData.find((element) => {
    //                                 return element?.value?.id === serviceCityField?.value?.id;
    //                             }) : ""}
    //                             isDisabled={rateObj?.id ? true : false}
    //                             onChange={handleServiceCitySelectChange}
    //                             placeholder="Select City"
    //                             options={cityData}
    //                         />
    //                     </div>
    //                     <span style={{ color: "red" }}>{errors?.serviceCity?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Car Type</Label>
    //                 <Col lg="12">
    //                     <div className="city-select">
    //                         <CustomSelect
    //                             className="service-select"
    //                             classNamePrefix="select"
    //                             isClearable={false}
    //                             isSearchable={false}
    //                             value={carTypeField?.value?.id ? carTypeData.find((element) => {
    //                                 return element?.value?.id === carTypeField?.value?.id;
    //                             }) : ""}
    //                             isDisabled={serviceCityField?.value?.id ? false : true}
    //                             onChange={handleCarTypeSelectChange}
    //                             placeholder={
    //                                 serviceCityField?.value?.id
    //                                     ? "Select Car Type"
    //                                     : "Select city to select car type"
    //                             }
    //                             options={carTypeData}
    //                         />
    //                     </div>
    //                     <span style={{ color: "red" }}>{errors?.carTypeDropdown?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Ride Type</Label>
    //                 <Col lg="12">
    //                     <div className="city-select">
    //                         <Select
    //                             className="service-select"
    //                             classNamePrefix="select"
    //                             isClearable={false}
    //                             isSearchable={false}
    //                             value={rideTypeField?.value ? rideTypeData.find((element) => {
    //                                 return element?.value === rideTypeField?.value;
    //                             }) : ""}
    //                             onChange={handleRideTypeSelectChange}
    //                             placeholder="Select Ride Type"
    //                             options={rideTypeData}
    //                         />
    //                     </div>
    //                     <span style={{ color: "red" }}>{errors?.rideType?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Booking Source</Label>
    //                 <Col lg="12">
    //                     <div className="city-select">
    //                         <Select
    //                             className="service-select"
    //                             classNamePrefix="select"
    //                             isClearable={false}
    //                             isSearchable={false}
    //                             value={bookingSourceField?.value ? bookingSourceData.find((element) => {
    //                                 return element?.value === bookingSourceField?.value;
    //                             }) : ""}
    //                             onChange={handleBookingSourceSelectChange}
    //                             placeholder="Select Booking Source"
    //                             options={bookingSourceData}
    //                         />
    //                     </div>
    //                     <span style={{ color: "red" }}>{errors?.bookingSource?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Airport</Label>
    //                 <Col lg="12">
    //                     <div className="city-select">
    //                         <CustomSelect
    //                             className="service-select"
    //                             classNamePrefix="select"
    //                             isClearable={false}
    //                             isSearchable={false}
    //                             isDisabled={serviceCityField?.value?.id ? false : true}
    //                             value={airportCityData.find((element) => {
    //                                 return element?.value?.name == airportField?.value?.name;
    //                             })}
    //                             onChange={handleAirportSelectChange}
    //                             placeholder={
    //                                 serviceCityField?.value?.id ?
    //                                     "Select airport" :
    //                                     "Select city to select airport"
    //                             }
    //                             options={airportCityData}
    //                         />
    //                         <span style={{ color: "red" }}>{errors?.airportDropdown?.message}</span>
    //                     </div>
    //                 </Col>
    //             </FormGroup>

    //             {/* <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Base Fare Tax</Label>
    //                 <Col lg="12">
    //                     <div className="city-select">
    //                         <CustomSelect
    //                             className="service-select"
    //                             classNamePrefix="select"
    //                             isClearable={false}
    //                             isSearchable={false}
    //                             value={baseFareTaxField?.value?.id ? taxData.find((element) => {
    //                                 return element?.value?.id === baseFareTaxField?.value?.id;
    //                             }) : ""}
    //                             onChange={handleBaseFareTax}
    //                             placeholder="Select Base Fare Tax"
    //                             options={taxData}
    //                         />
    //                     </div>
    //                     <span style={{ color: "red" }}>{errors?.baseFareTax?.message}</span>
    //                 </Col>
    //             </FormGroup> */}

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Tax</Label>
    //                 <Col lg="12">
    //                     <div className="city-select">
    //                         {/* <CustomSelect
    //                             className="service-select"
    //                             classNamePrefix="select"
    //                             isClearable={false}
    //                             isSearchable={false}
    //                             value={selectedTax}
    //                             onChange={(e)=>{
    //                                 setSelectedTax(e)
    //                                 setValue("baseFareTax",e.value.baseTax)
    //                                 setValue("serviceTax",e.value.serviceTax)
    //                             }}
    //                             placeholder="Select Tax"
    //                             options={combinedTax}
    //                         /> */}
    //                         <Select
    //                         value={overallTax}
    //                         {...register("overallTax")}
    //                         options={combinedTax}
    //                         onChange={(e)=>{
    //                             setValue("overallTax",e)
    //                             setValue("baseFareTax",e.value.baseTax)
    //                             setValue("serviceTax",e.value.serviceTax)
    //                         }}
    //                         />
    //                     </div>
    //                     <span style={{ color: "red" }}>{errors?.serviceTax?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Available From</Label>
    //                 <Col lg="12">
    //                     <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
    //                         <DatePicker
    //                             className="form-control datetimepicker-input digits"
    //                             selected={applicableFromDateField.value}
    //                             // showTimeSelect
    //                             showYearDropdown
    //                             showMonthDropdown
    //                             scrollableYearDropdown
    //                             onChange={handleApplicableFromDate}
    //                             dateFormat="MMMM d yyyy"
    //                             onKeyDown={(e) => {
    //                                 e.preventDefault();
    //                             }}
    //                         />
    //                     </InputGroup>
    //                     <span style={{ color: "red" }}>{errors?.applicableFromDate?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Available To</Label>
    //                 <Col lg="12">
    //                     <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
    //                         <DatePicker
    //                             className="form-control datetimepicker-input digits"
    //                             selected={applicableToDateField.value}
    //                             // showTimeSelect
    //                             showYearDropdown
    //                             showMonthDropdown
    //                             scrollableYearDropdown
    //                             onChange={handleApplicableToDate}
    //                             dateFormat="MMMM d yyyy"
    //                             onKeyDown={(e) => {
    //                                 e.preventDefault();
    //                             }}
    //                         />
    //                     </InputGroup>
    //                     <span style={{ color: "red" }}>{errors?.applicableToDate?.message}</span>
    //                 </Col>
    //             </FormGroup>
    //         </Row>

    //         <Row>
    //             <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
    //         </Row>

    //         {isAdvanced ? <Row>
    //             <FormGroup className="col-lg-6">
    //                 <Label className="col-lg-12 col-form-label">Corporate Client</Label>
    //                 <Col lg="12">
    //                     <div className="city-select">
    //                         <CustomSelect
    //                             className="service-select"
    //                             classNamePrefix="select"
    //                             isClearable={false}
    //                             isSearchable={false}
    //                             value={corporateClientField?.value?.id ? corporateClientData.find((element) => {
    //                                 return element?.value?.id === corporateClientField?.value?.id;
    //                             }) : ""}
    //                             isDisabled={serviceCityField?.value?.id ? false : true}
    //                             onChange={handleCorporateClientSelectChange}
    //                             placeholder={
    //                                 serviceCityField?.value?.id
    //                                     ? "Select Corporate Client"
    //                                     : "Select city to select corporate client"
    //                             }
    //                             options={corporateClientData}
    //                         />
    //                     </div>
    //                     <span style={{ color: "red" }}>{errors?.corporateClient?.message}</span>
    //                 </Col>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6" style={{ display: "flex", alignItems: "center" }}>
    //                 <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
    //                     <Input id="isNightfareTimeSlot" type="checkbox" checked={isNightfareTimeSlotField.value}
    //                         onChange={(value) => isNightfareTimeSlotField.onChange(value)} />
    //                     <Label className="mb-0" for="isNightfareTimeSlot">{"Is Night Fare"}</Label>
    //                 </div>
    //             </FormGroup>

    //             <FormGroup className="col-lg-6">

    //                 <Label className="col-lg-12 col-form-label">Trip Time Charge Per Min</Label>
    //                 <Col lg="12">
    //                     <input
    //                         className="form-control"
    //                         type="text"
    //                         pattern="[0-9.]+"
    //                         {...register("tripTimeChargePerMin", {
    //                             onChange: (e) => {
    //                                 let value = e.target.value.replace(/[^\d.-]/g, '');
    //                                 let sanitizedValue = value.replace(/(\.|\-)(?=.*\1)/g, '');
    //                                 setValue("tripTimeChargePerMin", sanitizedValue)
    //                             }
    //                         })}
    //                     />
    //                     <span style={{ color: "red" }}>{errors?.tripTimeChargePerMin?.message}</span>
    //                 </Col>

    //             </FormGroup>

    //             <FormGroup className="col-lg-6">

    //                 <Label className="col-lg-12 col-form-label">Discount Location Id</Label>
    //                 <Col lg="12">
    //                     <input
    //                         className="form-control"
    //                         type="text"
    //                         pattern="[0-9.]+"
    //                         {...register("discountLocationId", {
    //                         })}
    //                     />
    //                 </Col>
    //             </FormGroup>

    //         </Row> : null}
    //         <div style={{ display: "flex", justifyContent: "center" }}>
    //             <button type="submit" className="btn submit-button" disabled={isSubmitting}>
    //                 {rateObj?.id ? "Update" : "Create"}
    //             </button>
    //         </div>

    //     </Form>
    // </CommonModal>
    <Drawer
      anchor="right"
      open={open}
      onClose={() => setIsOpen(false)}
      PaperProps={{
        sx: {
          width: "43vw",
          borderTopLeftRadius: "1.49vw",
          borderBottomLeftRadius: "1.49vw",
        },
      }}
      sx={{
        "& .MuiDrawer-paper": {
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE & Edge
          "&::-webkit-scrollbar": {
            display: "none", // Chrome, Safari
          },
        },
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            flex: 1,
            backgroundColor: "rgba(244, 247, 253, 1)",
            height: "3vw",
          }}
        >
          <Box
            sx={{
              paddingTop: "1vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              width: "40%",
              gap: "1vw",
            }}
          >
            <img
              src={closeIcon}
              alt={"close"}
              style={{ width: "1.79vw", height: "1.79vw" }}
              onClick={() => setIsOpen(false)}
            />
            <Box
              sx={{
                width: "0.56vw",
                height: "0.56vw",
                background: "rgba(57, 181, 74, 1)",
                borderRadius: "30%",
              }}
            />
            <Typography
              sx={{
                color: "rgba(57, 181, 74, 1)",
                fontSize: "1.11vw",
                fontWeight: "600",
              }}
            >
              {editId ? "Edit Rate" : "Create Rate"}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            marginX: "1.04vw",
            marginTop: "0.69vw",
            // border: "1px solid red",
            paddingX: "0.69vw",
          }}
        >
          <Form onSubmit={handleSubmit(onFormSubmit)}>
            <Row>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Time From (Hours)
                </Label>
                <Col lg="12">
                  <InputGroup
                    className="date"
                    id="dt-minimum"
                    data-target-input="nearest"
                  >
                    <DatePicker
                      className="form-control datetimepicker-input digits"
                      selected={timeFromField.value}
                      onChange={handleTimeFrom}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={60}
                      timeCaption="Time"
                      dateFormat="hh:mm aa"
                      timeFormat="hh:mm aa"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </InputGroup>
                  <span style={{ color: "red" }}>
                    {errors?.timeFrom?.message}
                  </span>
                </Col>
              </FormGroup>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Time To (Hours)
                </Label>
                <Col lg="12">
                  <InputGroup
                    className="date"
                    id="dt-minimum"
                    data-target-input="nearest"
                  >
                    <DatePicker
                      className="form-control datetimepicker-input digits"
                      selected={timeToField.value}
                      onChange={handleTimeTo}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={60}
                      timeCaption="Time"
                      dateFormat="hh:mm aa"
                      timeFormat="hh:mm aa"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </InputGroup>
                  <span style={{ color: "red" }}>
                    {errors?.timeTo?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Initial Distance
                </Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    pattern="[0-9.]+"
                    {...register("initialDist", {
                      required: {
                        value: true,
                        message: "Initial Distance is required",
                      },
                      onChange: (e) => {
                        let value = e.target.value.replace(/[^\d.-]/g, "");
                        let sanitizedValue = value.replace(
                          /(\.|\-)(?=.*\1)/g,
                          ""
                        );
                        setValue("initialDist", sanitizedValue);
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.initialDist?.message}
                  </span>
                </Col>
              </FormGroup>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Initial Distance Charge
                </Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    pattern="[0-9.]+"
                    {...register("initialDistCharge", {
                      required: {
                        value: true,
                        message: "Initial Distance Charge is required",
                      },
                      onChange: (e) => {
                        let value = e.target.value.replace(/[^\d.-]/g, "");
                        let sanitizedValue = value.replace(
                          /(\.|\-)(?=.*\1)/g,
                          ""
                        );
                        setValue("initialDistCharge", sanitizedValue);
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.initialDistCharge?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Per Km Charge
                </Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    pattern="[0-9.]+"
                    {...register("perKmCharge", {
                      required: {
                        value: true,
                        message: "Per Km Charge is required",
                      },
                      validate: (value) => validatePerKmCharge(value, rewardConstraints),
                      onChange: (e) => {
                        let value = e.target.value.replace(/[^\d.-]/g, "");
                        let sanitizedValue = value.replace(
                          /(\.|\-)(?=.*\1)/g,
                          ""
                        );
                        setValue("perKmCharge", sanitizedValue);
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.perKmCharge?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Waiting Fee (per minute)
                </Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    pattern="[0-9.]+"
                    {...register("waitingChargePerMin", {
                      required: {
                        value: true,
                        message: "Waiting Fee is required",
                      },
                      onChange: (e) => {
                        let value = e.target.value.replace(/[^\d.-]/g, "");
                        let sanitizedValue = value.replace(
                          /(\.|\-)(?=.*\1)/g,
                          ""
                        );
                        setValue("waitingChargePerMin", sanitizedValue);
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.waitingChargePerMin?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Free Waiting Time (minutes)
                </Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    pattern="[0-9.]+"
                    {...register("waitingChargeAfterTimeInMin", {
                      required: {
                        value: true,
                        message: "Free Waiting Time is required",
                      },
                      onChange: (e) => {
                        let value = e.target.value.replace(/[^\d.-]/g, "");
                        let sanitizedValue = value.replace(
                          /(\.|\-)(?=.*\1)/g,
                          ""
                        );
                        setValue("waitingChargeAfterTimeInMin", sanitizedValue);
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.waitingChargeAfterTimeInMin?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Waiting Charge Applies Below Speed (km/h)
                </Label>
                <Col lg="12">
                  <input
                    className="form-control"
                    type="text"
                    pattern="[0-9.]+"
                    {...register("waitingCalcThresholdSpeed", {
                      required: {
                        value: true,
                        message:
                          "Speed is required to calculate waiting charges.",
                      },
                      onChange: (e) => {
                        let value = e.target.value.replace(/[^\d.-]/g, "");
                        let sanitizedValue = value.replace(
                          /(\.|\-)(?=.*\1)/g,
                          ""
                        );
                        setValue("waitingCalcThresholdSpeed", sanitizedValue);
                      },
                    })}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.waitingCalcThresholdSpeed?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Service City</Label>
                <Col lg="12">
                  <div className="city-select">
                    <CustomSelect
                      className="service-select"
                      classNamePrefix="select"
                      isClearable={false}
                      isSearchable={false}
                      value={
                        serviceCityField?.value?.id
                          ? cityData.find((element) => {
                              return (
                                element?.value?.id ===
                                serviceCityField?.value?.id
                              );
                            })
                          : ""
                      }
                      isDisabled={rateObj?.id ? true : false}
                      onChange={handleServiceCitySelectChange}
                      placeholder="Select City"
                      options={cityData}
                    />
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.serviceCity?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Car Type</Label>
                <Col lg="12">
                  <div className="city-select">
                    <CustomSelect
                      className="service-select"
                      classNamePrefix="select"
                      isClearable={false}
                      isSearchable={false}
                      value={
                        carTypeField?.value?.id
                          ? carTypeData.find((element) => {
                              return (
                                element?.value?.id === carTypeField?.value?.id
                              );
                            })
                          : ""
                      }
                      isDisabled={serviceCityField?.value?.id ? false : true}
                      onChange={handleCarTypeSelectChange}
                      placeholder={
                        serviceCityField?.value?.id
                          ? "Select Car Type"
                          : "Select city to select car type"
                      }
                      options={carTypeData}
                    />
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.carTypeDropdown?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Ride Type</Label>
                <Col lg="12">
                  <div className="city-select">
                    <Select
                      className="service-select"
                      classNamePrefix="select"
                      isClearable={false}
                      isSearchable={false}
                      value={
                        rideTypeField?.value
                          ? rideTypeData.find((element) => {
                              return element?.value === rideTypeField?.value;
                            })
                          : ""
                      }
                      onChange={handleRideTypeSelectChange}
                      placeholder="Select Ride Type"
                      options={rideTypeData}
                    />
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.rideType?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Booking Source
                </Label>
                <Col lg="12">
                  <div className="city-select">
                    <Select
                      className="service-select"
                      classNamePrefix="select"
                      isClearable={false}
                      isSearchable={false}
                      value={
                        bookingSourceField?.value
                          ? bookingSourceData.find((element) => {
                              return (
                                element?.value === bookingSourceField?.value
                              );
                            })
                          : ""
                      }
                      onChange={handleBookingSourceSelectChange}
                      placeholder="Select Booking Source"
                      options={bookingSourceData}
                    />
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.bookingSource?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Airport</Label>
                <Col lg="12">
                  <div className="city-select">
                    <CustomSelect
                      className="service-select"
                      classNamePrefix="select"
                      isClearable={false}
                      isSearchable={false}
                      isDisabled={!serviceCityField?.value?.id}
                      value={
                        airportField?.value?.id
                          ? airportCityData.find(
                              (a) => a.value.id === airportField.value.id
                            )
                          : null
                      }
                      onChange={handleAirportSelectChange}
                      placeholder={
                        serviceCityField?.value?.id
                          ? "Select airport"
                          : "Select city to select airport"
                      }
                      options={airportCityData}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.airportDropdown?.message}
                    </span>
                  </div>
                </Col>
              </FormGroup>

              {/* <FormGroup className="col-lg-6">
                    <Label className="col-lg-12 col-form-label">Base Fare Tax</Label>
                    <Col lg="12">
                        <div className="city-select">
                            <CustomSelect
                                className="service-select"
                                classNamePrefix="select"
                                isClearable={false}
                                isSearchable={false}
                                value={baseFareTaxField?.value?.id ? taxData.find((element) => {
                                    return element?.value?.id === baseFareTaxField?.value?.id;
                                }) : ""}
                                onChange={handleBaseFareTax}
                                placeholder="Select Base Fare Tax"
                                options={taxData}
                            />
                        </div>
                        <span style={{ color: "red" }}>{errors?.baseFareTax?.message}</span>
                    </Col>
                </FormGroup> */}

              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Tax</Label>
                <Col lg="12">
                  <div className="city-select">
                    {/* <CustomSelect
                                className="service-select"
                                classNamePrefix="select"
                                isClearable={false}
                                isSearchable={false}
                                value={selectedTax}
                                onChange={(e)=>{
                                    setSelectedTax(e)
                                    setValue("baseFareTax",e.value.baseTax)
                                    setValue("serviceTax",e.value.serviceTax)
                                }}
                                placeholder="Select Tax"
                                options={combinedTax}
                            /> */}
                    <Select
                      value={overallTax}
                      {...register("overallTax")}
                      options={combinedTax}
                      onChange={(e) => {
                        setValue("overallTax", e);
                        setValue("baseFareTax", e.value.baseTax, {
                          shouldValidate: true,
                        });
                        setValue("serviceTax", e.value.serviceTax, {
                          shouldValidate: true,
                        });
                      }}
                    />
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.serviceTax?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">
                  Available From
                </Label>
                <Col lg="12">
                  <InputGroup
                    className="date"
                    id="dt-minimum"
                    data-target-input="nearest"
                  >
                    <DatePicker
                      className="form-control datetimepicker-input digits"
                      selected={applicableFromDateField.value}
                      // showTimeSelect
                      showYearDropdown
                      showMonthDropdown
                      scrollableYearDropdown
                      onChange={handleApplicableFromDate}
                      dateFormat="MMMM d yyyy"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </InputGroup>
                  <span style={{ color: "red" }}>
                    {errors?.applicableFromDate?.message}
                  </span>
                </Col>
              </FormGroup>

              <FormGroup className="col-lg-6">
                <Label className="col-lg-12 col-form-label">Available To</Label>
                <Col lg="12">
                  <InputGroup
                    className="date"
                    id="dt-minimum"
                    data-target-input="nearest"
                  >
                    <DatePicker
                      className="form-control datetimepicker-input digits"
                      selected={applicableToDateField.value}
                      // showTimeSelect
                      showYearDropdown
                      showMonthDropdown
                      scrollableYearDropdown
                      onChange={handleApplicableToDate}
                      dateFormat="MMMM d yyyy"
                      onKeyDown={(e) => {
                        e.preventDefault();
                      }}
                    />
                  </InputGroup>
                  <span style={{ color: "red" }}>
                    {errors?.applicableToDate?.message}
                  </span>
                </Col>
              </FormGroup>
            </Row>
            <Row>
              <FormGroup
                className="col-lg-6"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className={
                    mix_background_layout == "dark-only"
                      ? "checkbox-dark p-0"
                      : "checkbox p-0"
                  }
                >
                  <Input
                    id="IsActive"
                    type="checkbox"
                    checked={isActiveField.value}
                    onChange={(value) => isActiveField.onChange(value)}
                  />
                  <Label className="mb-0" for="IsActive">
                    {"Available {Yes/No}"}
                  </Label>
                </div>
              </FormGroup>

              {/* <FormGroup
                className="col-lg-6"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className={
                    mix_background_layout == "dark-only"
                      ? "checkbox-dark p-0"
                      : "checkbox p-0"
                  }
                >
                  <Input
                    id="IsPriority"
                    type="checkbox"
                    checked={isPriorityField.value}
                    onChange={(value) => isPriorityField.onChange(value)}
                  />
                  <Label className="mb-0" for="IsPriority">
                    {"Is Priority"}
                  </Label>
                </div>
              </FormGroup> */}
            </Row>
            <Row>
              <div
                style={{
                  color: "#11BF5C",
                  textDecoration: "underline",
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => setIsAdvanced(!isAdvanced)}
              >
                Advanced Configurations{" "}
                {isAdvanced ? (
                  <ArrowUp
                    style={{ width: "15px", height: "15px", marginLeft: "5px" }}
                  />
                ) : (
                  <ArrowDown
                    style={{ width: "15px", height: "15px", marginLeft: "5px" }}
                  />
                )}
              </div>
            </Row>

            {isAdvanced ? (
              <Row>
                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Corporate Client
                  </Label>
                  <Col lg="12">
                    <div className="city-select">
                      <CustomSelect
                        className="service-select"
                        classNamePrefix="select"
                        isClearable={false}
                        isSearchable={false}
                        value={
                          corporateClientField?.value?.id
                            ? corporateClientData.find((element) => {
                                return (
                                  element?.value?.id ===
                                  corporateClientField?.value?.id
                                );
                              })
                            : ""
                        }
                        isDisabled={serviceCityField?.value?.id ? false : true}
                        onChange={handleCorporateClientSelectChange}
                        placeholder={
                          serviceCityField?.value?.id
                            ? "Select Corporate Client"
                            : "Select city to select corporate client"
                        }
                        options={corporateClientData}
                      />
                    </div>
                    <span style={{ color: "red" }}>
                      {errors?.corporateClient?.message}
                    </span>
                  </Col>
                </FormGroup>

                {/* <FormGroup
                  className="col-lg-6"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className={
                      mix_background_layout == "dark-only"
                        ? "checkbox-dark p-0"
                        : "checkbox p-0"
                    }
                  >
                    <Input
                      id="isNightfareTimeSlot"
                      type="checkbox"
                      checked={isNightfareTimeSlotField.value}
                      onChange={(value) =>
                        isNightfareTimeSlotField.onChange(value)
                      }
                    />
                    <Label className="mb-0" for="isNightfareTimeSlot">
                      {"Is Night Fare"}
                    </Label>
                  </div>
                </FormGroup>

                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Trip Time Charge Per Min
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9.]+"
                      {...register("tripTimeChargePerMin", {
                        onChange: (e) => {
                          let value = e.target.value.replace(/[^\d.-]/g, "");
                          let sanitizedValue = value.replace(
                            /(\.|\-)(?=.*\1)/g,
                            ""
                          );
                          setValue("tripTimeChargePerMin", sanitizedValue);
                        },
                      })}
                    />
                    <span style={{ color: "red" }}>
                      {errors?.tripTimeChargePerMin?.message}
                    </span>
                  </Col>
                </FormGroup>

                <FormGroup className="col-lg-6">
                  <Label className="col-lg-12 col-form-label">
                    Discount Location Id
                  </Label>
                  <Col lg="12">
                    <input
                      className="form-control"
                      type="text"
                      pattern="[0-9.]+"
                      {...register("discountLocationId", {})}
                    />
                  </Col>
                </FormGroup> */}
              </Row>
            ) : null}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="submit"
                className="btn submit-button"
                disabled={isSubmitting}
              >
                {rateObj?.id ? "Update" : "Create"}
              </button>
            </div>
          </Form>
        </Box>
      </Box>
    </Drawer>
  );
};

export default RateInput;
